<template>
  <component :is="dashboardComponent" />
</template>

<script>
import store from '@/store/store'

const getUserRole = () => store.state.user?.role || store.state.role || localStorage.getItem('role')

const redirectIfAdminDeveloper = next => {
  if (getUserRole() === 'admin_developer') {
    next({ name: 'invoice-list-direx' })
  } else {
    next()
  }
}

export default {
  name: 'DashboardWrapper',
  beforeRouteEnter(to, from, next) {
    redirectIfAdminDeveloper(next)
  },
  beforeRouteUpdate(to, from, next) {
    redirectIfAdminDeveloper(next)
  },
  computed: {
    dashboardComponent() {
      const role = getUserRole()
      if (role === 'accountant') {
        return () => import('@/views/AccountantDashboard.vue')
      }
      if (role === 'sales') {
        return () => import('@/views/SalesDashboard.vue')
      }
      return () => import('@/views/Home.vue')
    },
  },
}
</script>
